// IconsTab.jsx

import React from "react";

const IconsTab = () => {
  return <div className="text-center text-gray-400">Icons coming soon.</div>;
};

export default IconsTab;
